import { Book, Users, Award, Heart } from 'lucide-react';
import { Card, CardContent } from "./ui/card";

const features = [
  {
    icon: Book,
    title: "Interactive Learning",
    description: "Engaging activities and games that make learning enjoyable for children of all ages.",
    color: "bg-blue-100 text-blue-600"
  },
  {
    icon: Users,
    title: "Expert Teachers",
    description: "Qualified educators who understand child development and create nurturing environments.",
    color: "bg-green-100 text-green-600"
  },
  {
    icon: Award,
    title: "Achievement Tracking",
    description: "Monitor progress with personalized reports and celebrate every milestone reached.",
    color: "bg-purple-100 text-purple-600"
  },
  {
    icon: Heart,
    title: "Safe Environment",
    description: "A secure, supportive space where children can explore, learn, and grow confidently.",
    color: "bg-pink-100 text-pink-600"
  }
];

export function Features() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-medium">
            Why Choose Us
          </span>
          <h2 className="text-4xl font-bold text-gray-800 mt-4 mb-6">
            What Makes Us Different
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We believe every child deserves the best start in their educational journey. 
            Here's what sets our approach apart.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8 text-center">
                <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <feature.icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}